import React from "react";
import { useNavigate } from "react-router-dom";
import "./Landing.css";
import logo from "../assets/logolanding.png";

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="hero">
      <div className="hero-overlay" />

      <div className="hero-content">
        <img src={logo} alt="ReflectUS" className="hero-logo" />

        <p className="hero-tagline">
          A structured relational protocol.
        </p>

        <button
          className="enter-btn"
          onClick={() => navigate("/introduction")}
        >
          Enter
        </button>
      </div>
    </div>
  );
} 
